<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    typeInput: {
      type: String,
      default: "checkbox",
    },
  },
};
</script>

<template>
  <input
    class="input"
    @input="(event) => $emit('onChange', event)"
    type="checkbox"
    :checked="value"
  />
</template>
